<template>
  <div>
    <v-card class="mx-auto" max-width="1000" pb-5 pt-5>
      <v-carousel cycle hide-delimiter-background show-arrows-on-hover>
        <v-carousel-item v-for="(item,i) in article.items" :key="i">
          <v-img :src="item"></v-img>
        </v-carousel-item>
      </v-carousel>
      <v-list-item>
        <v-list-item-content>
          <v-btn text x-large @click="goTo(article.link, article.author)">
            <p class="text-center font-weight-bold display-1">{{article.title}}</p>
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <br />
  </div>
</template>

<script>
export default {
  props: ["article"],
  data() {
    return {};
  },
  methods: {
    goTo: function(page, author) {
      this.$router.push({ name: page, params: { author: author } });
    }
  }
};
</script>